import MarkerIcon from './Marker.svg';
import MarkerRedIcon from './MarkerRed.svg';
import StoreIcon from './Store.svg';

export function createMarkerEl({
  width,
  height,
  isSelected = false,
  isCluster = false,
  count = 0,
}: {
  height: number;
  width: number;
  isSelected?: boolean;
  isCluster?: boolean;
  count?: number;
}): HTMLElement {
  const el = document.createElement('div');

  el.style.position = 'relative';
  el.style.width = `${width}px`;
  el.style.height = `${height}px`;
  el.style.display = 'flex';
  el.style.alignItems = 'center';
  el.style.justifyContent = 'center';

  el.innerHTML = `
    <img
      src="${isSelected ? MarkerRedIcon : MarkerIcon}"
      style="
        position: absolute;
        width: 100%;
        height: 100%;
        display: block;
        left: 0px;
        top: 0px;
      "
      />    
  `;

  if (!isCluster) {
    el.innerHTML += `      
      <img
        src="${StoreIcon}"
        style="
          width: 20px;
          height: 20px;
          display: block;
          margin-bottom: 12px;
          z-index: 1000;
        "
      />
    `;
  }

  if (isCluster) {
    el.innerHTML += `      
      <div style="
        color: white;
        font-size: 11px;
        font-weight: 900;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
        z-index: 1000;
        padding-bottom: 12px;
      ">
        ${count < 1000 ? count : `1k+`}
      </div>`;
  }

  return el;
}

interface LatLng {
  lat: number;
  lng: number;
}

export function getMinimumUnclusteredZoom(
  a: LatLng,
  b: LatLng,
  clusterRadius = 60,
  minZoom = 0,
  maxZoom = 21,
): number {
  const project = ({ lat, lng }: LatLng) => {
    const sin = Math.sin((lat * Math.PI) / 180);

    return {
      x: (lng + 180) / 360,
      y: 0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI),
    };
  };

  const pa = project(a);
  const pb = project(b);

  for (let zoom = minZoom; zoom <= maxZoom; zoom++) {
    const worldSize = 256 * Math.pow(2, zoom);

    const ax = pa.x * worldSize;
    const ay = pa.y * worldSize;

    const bx = pb.x * worldSize;
    const by = pb.y * worldSize;

    const dx = ax - bx;
    const dy = ay - by;

    const pixelDistance = Math.hypot(dx * dx + dy * dy);

    if (pixelDistance >= clusterRadius) {
      return zoom;
    }
  }

  return maxZoom;
}
